<template>
  <main class="alert-detail_container">
    <div class="container__card">
      <header>
        <span class="text--header"> Alert Detail </span>
        <div v-if="canUpdate" class="delete--button">
          <atom-button
            buttonId="button-delete-alert"
            :styleInButton="deleteButtonStyle"
            @click="clickDelete"
            ><feather-icon
              icon="Trash2Icon"
              class="delete__icon--style"
            />Delete</atom-button
          >
        </div>
      </header>
      <section class="alert-detail__content">
        <div class="row">
          <div class="col-12 col-sm-7">
            <div class="input-name--width">
              <atom-input
                title="Alert Name"
                placeholder="Alert Name"
                :isAsterisk="canUpdate"
                :isError="validateAlertNameInputError"
                :errorMessage="alertNameInputErrorMessage"
                :isDisable="!canUpdate"
                v-model="alertDetail.alertName"
              ></atom-input>
            </div>
            <div class="input--margin-top">
              <atom-input
                title="Description"
                v-model="alertDetail.alertDescription"
                placeholder="Description"
                :isDisable="!canUpdate"
              ></atom-input>
            </div>
            <div class="input--margin-top">
              <atom-input
                title="Alert SMS Gateway Path"
                v-model="alertDetail.alertGateway"
                placeholder="Alert SMS Gateway Path"
                :isDisable="!canUpdate"
              ></atom-input>
              <div class="text--description">
                <span>
                  http://smsgatewaypath.example.com/?to=<span class="text--bold"
                    >{TO}</span
                  >&message=<span class="text--bold">{MESSAGE}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-5 mb-1">
            <div class="sub-card__container">
              <div class="sub-card__container--header">
                <span class="text--normal">Enable Alert Threshold</span>
                <atom-switch
                  v-model="alertDetail.alertEnableThreshold"
                  :isDisable="!canUpdate"
                  @change="onEnableThresholdToggle"
                ></atom-switch>
              </div>
              <div class="sub-card__container--content">
                <div
                  class="text--normal text--semi-bold text--grey text--uppercase topic--margin-bottom"
                >
                  <span> Threshold Interval (Minute) </span>
                </div>
                <div class="input__threshold--width">
                  <atom-input
                    v-model="alertDetail.intervalThreshold"
                    placeholder="5"
                    :isDisable="!alertDetail.alertEnableThreshold || !canUpdate"
                    :isError="validateIntervalThresholdInputError"
                  ></atom-input>
                </div>
                <label
                  v-if="validateIntervalThresholdInputError"
                  class="error-message-style"
                  >{{ intervalThresholdInputErrorMessage }}</label
                >
              </div>
              <div class="sub-card__container--content">
                <div
                  class="text--normal text--semi-bold text--grey text--uppercase topic--margin-bottom topic--margin-top"
                >
                  <span> Maximum Alert Count </span>
                </div>
                <div class="input__threshold--width">
                  <atom-input
                    v-model="alertDetail.maximumAlertCount"
                    placeholder="5"
                    :isDisable="!alertDetail.alertEnableThreshold || !canUpdate"
                    :isError="validateMaximumAlertCountInputError"
                  ></atom-input>
                </div>
                <label
                  v-if="validateMaximumAlertCountInputError"
                  class="error-message-style"
                  >{{ intervalThresholdInputErrorMessage }}</label
                >
                <div class="text--description">
                  <span>
                    Example: Only send 5 alerts within 5 minutes, otherwise skip
                    alert
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
export default {
  components: { AtomInput, AtomSwitch, AtomButton },
  name: "MoleculeModificationAlertDetail",
  props: {
    mode: {
      type: String,
      required: true,
    },
    alertData: {
      type: Object,
      required: false,
      //default: {},
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["alertDetail", "clickDelete", "onErrorValidation"],
  data() {
    return {
      alertDetail: {
        alertId: "",
        alertName: "",
        alertDescription: "",
        alertGateway: "",
        alertEnable: false,
        alertEnableThreshold: true,
        intervalThreshold: null,
        maximumAlertCount: null,
      },
      alertNameInputErrorMessage: "Please enter alert name",
      intervalThresholdInputErrorMessage:
        "Value must greater than or equal to 1",
      maximumAlertCountErrorMessage: "Value must greater than or equal to 1",
      deleteButtonStyle:
        "background-color: #F6E4E4 !important;color: #EA5455 !important; border-color: #F6E4E4 !important",
    }
  },
  computed: {
    validateAlertNameInputError() {
      if (this.isValidateTrigger) {
        return this.isEmptyString(this.alertDetail.alertName)
      }
      return false
    },
    validateIntervalThresholdInputError() {
      if (this.isValidateTrigger && this.alertDetail.alertEnableThreshold) {
        return !this.isValidInteger(this.alertDetail.intervalThreshold)
      }
      return false
    },
    validateMaximumAlertCountInputError() {
      if (this.isValidateTrigger && this.alertDetail.alertEnableThreshold) {
        return !this.isValidInteger(this.alertDetail.maximumAlertCount)
      }
      return false
    },
    validateAllInputError() {
      return (
        this.validateAlertNameInputError ||
        this.validateIntervalThresholdInputError ||
        this.validateMaximumAlertCountInputError
      )
    },
  },
  watch: {
    alertDetail: {
      deep: true,
      handler() {
        this.$emit("alertDetail", this.alertDetail)
        if (this.isValidateTrigger) {
          this.$emit("onErrorValidation", this.validateAllInputError)
        }
      },
    },
    isValidateTrigger() {
      if (this.isValidateTrigger) {
        this.$emit("onErrorValidation", this.validateAllInputError)
      }
    },
  },

  mounted() {
    if (this.mode === "edit") {
      this.cloneData()
    }
  },

  methods: {
    cloneData() {
      this.alertDetail = {
        alertId: this.alertData.alertId,
        alertName: this.alertData.alertName,
        alertDescription: this.alertData.alertDescription,
        alertGateway: this.alertData.alertGateway,
        alertEnable: this.alertData.alertEnable,
        alertEnableThreshold: this.alertData.alertEnableThreshold,
        intervalThreshold: this.alertData.intervalThreshold,
        maximumAlertCount: this.alertData.maximumAlertCount,
      }
    },
    clickDelete() {
      this.$emit("clickDelete")
    },
    onEnableThresholdToggle() {
      if (!this.alertData.alertEnableThreshold) {
        if (!this.isValidInteger(this.alertDetail.intervalThreshold)) {
          this.alertDetail.intervalThreshold = 5
        }
        if (!this.isValidInteger(this.alertDetail.maximumAlertCount)) {
          this.alertDetail.maximumAlertCount = 5
        }
      }
    },
    isEmptyString(input) {
      return input === null || input.trim() === ""
    },
    isValidInteger(input, min = 1) {
      if (input === null || input < min) return false
      const regex = /^[0-9]+$/
      return regex.test(input)
    },
  },
}
</script>

<style lang="scss" scoped>

.alert-detail_container .delete--button ::v-deep { 
  .btn-primary:hover:not(.disabled):not(:disabled){
    box-shadow: none;
  }
}

header {
  display: flex;
  justify-content: space-between;
}

.container__card {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  padding: 1.5rem 1.5rem 0.75rem 1.5rem;
}

.text--header {
  padding-top: 8px;
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.text--normal {
  font-weight: 400;
  font-size: 12px;
}

.text--description {
  margin-top: 8px;
  color: #b9b9c3;
  font-weight: 400;
  font-size: 10px;
}

.text--semi-bold {
  font-weight: 500;
}

.text--bold {
  font-weight: 600;
}

.text--grey {
  color: #b9b9c3;
}

.text--uppercase {
  text-transform: uppercase;
}

.alert-detail__content {
  margin-top: 20px;
}

.input--margin-top {
  margin-top: 5px;
}

.topic--margin-top {
  margin-top: 15px;
}

.topic--margin-bottom {
  margin-bottom: 8px;
}

.sub-card__container {
  height: 98%;
  background: #ffffff;
  border: 1px solid #b9b9c3;
  border-radius: 6px;
  padding: 16px 10px 2px 20px;
  margin-top: 15px;
}

.sub-card__container--header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.input__threshold--width {
  width: 132px;
}

.delete--button {
  display: flex;
}

.delete__icon--style {
  margin-right: 5px;
}

.error-message-style {
  font-size: 12px;
  color: #ea5455;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .text--header {
    padding-top: 0;
  }
  .delete--button {
    display: none;
  }
  .input-name--width {
    width: 80%;
  }
  .sub-card__container {
    margin-top: 0;
    padding: 16px 10px 18px 20px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
